import { alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = (onOff) =>
  makeStyles(() =>
    createStyles({
      switch: {
        display: 'flex',
        fontSize: 0,
      },
      input: {
        height: 0,
        width: 0,
        visibility: 'hidden',
        margin: 0,
        '&:checked + $label::after': {
          left: 'calc(100% - 5px)',
          transform: 'translateX(-100%)',
          background: colorsPalette.primary,
        },
      },
      label: {
        cursor: 'pointer',
        textIndent: '-9999px',
        width: 58,
        height: 31,
        background: colorsPalette.violetAnalyticsCard,
        display: 'block',
        fontSize: 16,
        borderRadius: '999em',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 4,
          left: 5,
          width: 24,
          height: 24,
          background: onOff ? alpha(colorsPalette.white, 0.3) : colorsPalette.primary,
          borderRadius: '100%',
          transition: '0.3s',
        },
      },
    }),
  );

export default useStyles;
